/*
* Broadcast Theme
*
* Use this file to add custom Javascript to Broadcast.  Keeping your custom
* Javascript in this fill will make it easier to update Broadcast. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*/


(function() {
  // Add custom code below this line


  
document.querySelectorAll('.klaviyo-bis-trigger').forEach(function(button) {
  button.addEventListener('click', function() {
    window._klOnsite = window._klOnsite || [];
    window._klOnsite.push(['openBackInStockModal', {
      variantId: button.getAttribute('data-variant-id'),
      productId: button.getAttribute('data-product-id'),
      productName: button.getAttribute('data-product-name'),
      productUrl: button.getAttribute('data-product-url')
    }]);
  });
});

if (window.location.search.includes('notifyme=true')) {
  setTimeout(function() {
    var trigger = document.querySelector('a.klaviyo-bis-trigger');
    if (trigger) trigger.click();
  }, 200);
}


/* Frankly Media: länk till gåvopolicyn i gåvopopupen från EG Auto Add to Cart (#aca-modal).
   Popupen skapas av appen, så länken läggs in när popupen dyker upp. Stil i frankly-custom.css. */
(function () {
  var URL = 'https://nikben.com/pages/delivery-returns#free-gifts';
  var TEXT = 'Read more about our free gift policy';
  function addGiftPolicyLink() {
    var container = document.querySelector('#aca-modal #aca-products-container');
    if (!container || document.querySelector('#aca-modal .nb-gift-policy')) return;
    var p = document.createElement('p');
    p.className = 'nb-gift-policy';
    var a = document.createElement('a');
    a.href = URL;
    a.textContent = TEXT;
    a.target = '_blank';
    a.rel = 'noopener';
    p.appendChild(a);
    container.parentNode.insertBefore(p, container.nextSibling);
  }
  var queued = false;
  new MutationObserver(function () {
    if (queued) return;
    queued = true;
    requestAnimationFrame(function () { queued = false; addGiftPolicyLink(); });
  }).observe(document.body, { childList: true, subtree: true });
  addGiftPolicyLink();
})();


  // ^^ Keep your scripts inside this IIFE function call to 
  // avoid leaking your variables into the global scope.
})();
